import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageHtmlUpdater = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const lang = i18n.language;
    document.documentElement.setAttribute('lang', lang?.toLowerCase());
  }, [i18n.language]);

  return null;
};

export default LanguageHtmlUpdater;
